import FormattedMessage from 'I18n/components/FormattedMessage';
import { ChannelTypes } from 'conversations-internal-schema/constants/ChannelTypes';
import { BOT } from 'conversations-internal-schema/routing-rules/constants/RoutingTypes';
import { jsx as _jsx } from "react/jsx-runtime";
export const ChannelTypeTag = ({
  type
}) => {
  switch (type) {
    case ChannelTypes.EMAIL:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-conversations-settings-lib.migration.review.channel.type.email"
      });
    case ChannelTypes.FORMS:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-conversations-settings-lib.migration.review.channel.type.form"
      });
    case ChannelTypes.CHAT:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-conversations-settings-lib.migration.review.channel.type.liveChat"
      });
    case BOT:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-conversations-settings-lib.migration.review.channel.type.bot"
      });
    default:
      return null;
  }
};
ChannelTypeTag.displayName = 'ChannelTypeTag';